import {isTrue as isTrueUtil} from "../../libs/utils/epic.utils";

export class KeyValueDto {

  public key!: string;

  public value: string | null | undefined;

  constructor(init?: Partial<KeyValueDto>) {
    Object.assign(this, init);
  }

  public static of(key: string, value: string | null): KeyValueDto {
    return new KeyValueDto({key, value});
  }

  public isTrue(): boolean {
    return isTrueUtil(this.value);
  }
}
